var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, forwardRef } from "react";
import ReactDOM from "react-dom";
import useDropElement from "../../../hooks/use-drop-element";
import useKeyboardEsc from "../../../hooks/use-keyboard-esc";
import useOutsideClick from "../../../hooks/use-outside-click";
import useForwardRef from "../../../hooks/use-forward-ref";
import useDimensionChange from "./useDimensionChange";
import useMakeUpdatePosition from "./useMakeUpdatePosition";
import Container from "./container";
var defaultAlign = { top: "bottom", left: "left" };
var Drop = forwardRef(function (_a, parentRef) {
    var target = _a.target, _b = _a.align, align = _b === void 0 ? defaultAlign : _b, _c = _a.stretch, stretch = _c === void 0 ? "width" : _c, onClickOutside = _a.onClickOutside, onEsc = _a.onEsc, children = _a.children, _d = _a.canHideTarget, canHideTarget = _d === void 0 ? true : _d, rest = __rest(_a, ["target", "align", "stretch", "onClickOutside", "onEsc", "children", "canHideTarget"]);
    var _e = useForwardRef(parentRef), ref = _e[0], setRef = _e[1];
    var updatePosition = useMakeUpdatePosition(target, ref, align, stretch, canHideTarget);
    useEffect(function () {
        var id = requestAnimationFrame(updatePosition);
        return function () { return cancelAnimationFrame(id); };
    }, [updatePosition]);
    useDimensionChange(target, updatePosition);
    useOutsideClick(ref, onClickOutside);
    useKeyboardEsc(onEsc);
    var el = useDropElement();
    return ReactDOM.createPortal(React.createElement(Container, __assign({ ref: setRef, width: { max: "100%" }, column: true, "data-testid": "drop" }, rest), children), el);
});
export default Drop;
